var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: ["ui-radio", _vm.classList] }, [
    _c("label", { staticClass: "ui-radio-label", attrs: { for: _vm.id } }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.computedValue,
            expression: "computedValue"
          }
        ],
        attrs: {
          type: "radio",
          disabled: _vm.disabled,
          name: _vm.name,
          id: _vm.id
        },
        domProps: {
          value: _vm.option,
          checked: true,
          checked: _vm._q(_vm.computedValue, _vm.option)
        },
        on: {
          change: function($event) {
            _vm.computedValue = _vm.option
          }
        }
      }),
      _c("span", { class: ["ui-radio-input", { error: _vm.error }] }),
      _vm._v("\n\n    " + _vm._s(_vm.label) + "\n  ")
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }